import StatusBadge from './StatusBadge.component';
export default StatusBadge;
